module.exports = __webpack_public_path__ + "static/media/time.89b37d94.svg";